import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, Injector } from "@angular/core";
import { HttpModule } from "@angular/http";
import { RouterModule, Routes } from "@angular/router";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PageNotFoundComponent } from "./page-not-found.component";
import { CoreModule } from "./core/core.module";
import { ComponentModule } from "./components/component.module";
import { SmModule } from "./shell/sm/sm.module";
import { LoginModule } from "./login/login.module";
import { UserClientsModule } from "./userclients/userclients.module";

import {
  ToastModule,
  ToastsManager,
  ToastOptions,
} from "ng2-toastr/ng2-toastr";
import { ToastyModule } from "ng2-toasty";
import { AppConstants } from "./app.constant";
import { IxsReportModule } from "./components/ixs-report/ixs-report.module";
import { OnlineSessionModule } from "./shell/forms/shared-modals/online-session/online-session.module";
import { childsModule } from "./shell/Parent-Portal/childs/childs.module";
import { AboutModule } from "./about/about.module";
import { AdmissionFormModule } from "./admisform/admisform.module";

// Toaster
const toastOptions: ToastOptions = new ToastOptions({
  animate: "flyRight",
  positionClass: "toast-bottom-center",
  showCloseButton: true,
  toastLife: 10000,
  newestOnTop: false,
  dismiss: "controlled",
});

@NgModule({
  declarations: [AppComponent, PageNotFoundComponent],
  imports: [
    BrowserModule,
    HttpModule,
    RouterModule,
    CoreModule,
    ComponentModule,
    ToastModule,
    LoginModule,
    UserClientsModule,
    childsModule,
    OnlineSessionModule,
    SmModule,
    AppRoutingModule,
    AboutModule,
    AdmissionFormModule,

    FormsModule,
    ToastyModule.forRoot(),
    IxsReportModule,
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(injector: Injector) {
    AppConstants.injector = injector;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts